type FocusMapPositionParams = {
	map: naver.maps.Map;
	position: naver.maps.LatLng;
	targetY: number;
};

const TARGET_Y_OFFSET = 40;

const focusMapPosition = ({
	map,
	position,
	targetY,
}: FocusMapPositionParams): void => {
	const mapElement = map.getElement?.() as HTMLElement | undefined;
	const mapRect = mapElement?.getBoundingClientRect();
	const projection = map.getProjection();

	if (!mapRect || !projection) {
		map.panTo(position);
		return;
	}

	const currentOffset = projection.fromCoordToOffset(position);
	const viewportCenter = new naver.maps.Point(
		mapRect.width / 2,
		mapRect.height / 2,
	);
	const targetPoint = new naver.maps.Point(
		viewportCenter.x,
		targetY + TARGET_Y_OFFSET,
	);
	const adjustedCenterOffset = new naver.maps.Point(
		currentOffset.x + viewportCenter.x - targetPoint.x,
		currentOffset.y + viewportCenter.y - targetPoint.y,
	);

	map.panTo(projection.fromOffsetToCoord(adjustedCenterOffset));
};

export default focusMapPosition;
